import crudActions from '@/store/crudActions'
import axios from '@/libs/axios'

const endpoint = 'exam'
const Actions = crudActions(endpoint)
const orgDistributedQuote = ({ commit }, exam) => new Promise((resolve, reject) => {
  const { quarter } = exam
  const { organization } = exam
  if (quarter.quarter === 1) {
    axios.get('/org-distribute-quote/get_org_distributed_quote/', { params: { period_id: quarter.period, exam_id: exam.id } })
      .then(response => {
        commit('ORG_DISTRIBUTED_QUOTE', response.data)
        resolve(response)
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  } else {
    axios.get('/org-directions/', { params: { limit: 9999, org: organization.id } })
      .then(response => {
        commit('ORG_DISTRIBUTED_QUOTE', response.data.results)
        resolve(response)
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  }
})
const finish = (ctx, id) => new Promise((resolve, reject) => {
  axios.patch(`/${endpoint}/${id}/change_exam_status/`)
    .then(response => {
      resolve(response.data)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
export default {
  ...Actions,
  orgDistributedQuote,
  finish,
}
